import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../landing-publication/ext-profiles/ext-profiles.service";
import { IUser } from 'app/interfaces/IUser'

@Component({
    selector: 'app-user-localization-debug',
    templateUrl: './user-localization-debug.component.html',
    styleUrls: ['./user-localization-debug.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserLocalizationDebugComponent implements OnInit {

  cUser: IUser;
  userExt: string[];

  constructor(
      public userService: UserService,
      public extProfilesService: ExtProfilesService,
      private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {

    this.userService.user$.subscribe((aUser) => {

      this.cUser = aUser;
      this.userExt = Object.keys(aUser.extProfiles);

      this.cdr.markForCheck();

    })

  }

}
